import { z } from "zod";
import { peopleFiltersSchema, postFiltersSchema } from "../filters.schema";

export type FeedResponse<T> = {data: { results: T, nextPage: number  }} 

export const galleriesSort = ["new-to-old", "old-to-new"] as const;
export const feedSortOptions = [
  "new-to-old",
  "old-to-new",
  'algorithmic',
  "seeds-most-to-least",
  "seeds-least-to-most",
] as const;
export const peopleSortOptions = [
  "new-to-old",
  "old-to-new",
  "recent-activity",
  "popularity",
  "seed-received",
] as const;

export const POST_explorePosts = {
  params: z.object({}),
  query: z.object({
    sort: z.enum(feedSortOptions).optional(),
  }),
  body: z.object({
    filters: postFiltersSchema.optional(),
  }),
};

export const POST_explorePeople = {
  params: z.object({}),
  query: z.object({
    sort: z.enum(peopleSortOptions).optional(),
  }),
  body: z.object({
    filters: peopleFiltersSchema.optional(),
  }),
};
